import * as actions from './actionsTypes';

const initialData = {
  loader: false,
  loaderNotNeedUpdate: false,
}

export default function updateUserDataReducer(state = initialData, action){
  switch (action.type) {
    case actions.REQUEST_CHANGES_LOADER_DATA:
      return {...state, loader: action.payload}
    case actions.REQUEST_CHANGES_NOT_NEED_UPDATE_LOADER_DATA:
      return {...state, loader: action.payload}
    default:
      return state
  }
}